// Static mock data for all API responses

export const staticProducts = [
  {
    id: 1,
    name: "منتج إلكتروني مميز",
    description: "هذا منتج إلكتروني عالي الجودة مع مواصفات رائعة",
    price: 99.99,
    images: [
      {
        image: "/images/12.png"
      },
      {
        image: "/images/3.png"
      }
    ],
    category: {
      main: { name: "Electronics" }
    },
    government: "دمشق",
    seller: {
      id: 1,
      name: "أحمد محمد",
      rating: 4.5,
      avatar: "/images/defualt.png"
    },
    comments: [],
    in_stock: 10,
    tags: []
  },
  {
    id: 2,
    name: "منتج ملابس أنيق",
    description: "ملابس عصرية وأنيقة بجودة عالية",
    price: 149.99,
    images: [
      {
        image: "/images/7.png"
      },
      {
        image: "/images/12.png"
      }
    ],
    category: {
      main: { name: "Clothing" }
    },
    government: "حلب",
    seller: {
      id: 2,
      name: "فاطمة علي",
      rating: 4.8,
      avatar: "/images/defualt.png"
    },
    comments: [],
    in_stock: 15,
    tags: []
  },
  {
    id: 3,
    name: "منتج للبيت والحديقة",
    description: "منتجات عالية الجودة للبيت والحديقة",
    price: 79.99,
    images: [
      {
        image: "/images/3.png"
      },
      {
        image: "/images/7.png"
      }
    ],
    category: {
      main: { name: "Home & Garden" }
    },
    government: "اللاذقية",
    seller: {
      id: 3,
      name: "خالد حسن",
      rating: 4.2,
      avatar: "/images/defualt.png"
    },
    comments: [],
    in_stock: 8,
    tags: []
  },
  {
    id: 4,
    name: "منتج رياضي",
    description: "معدات رياضية احترافية",
    price: 199.99,
    images: [
      {
        image: "/images/defualt.png"
      }
    ],
    category: {
      main: { name: "Sports" }
    },
    government: "طرطوس",
    seller: {
      id: 4,
      name: "سارة أحمد",
      rating: 4.7,
      avatar: "/images/defualt.png"
    },
    comments: [],
    in_stock: 20,
    tags: []
  },
  {
    id: 5,
    name: "منتج إلكتروني متقدم",
    description: "تكنولوجيا حديثة وأداء عالي",
    price: 299.99,
    images: [
      {
        image: "/images/12.png"
      }
    ],
    category: {
      main: { name: "Electronics" }
    },
    government: "حمص",
    seller: {
      id: 5,
      name: "محمد علي",
      rating: 4.9,
      avatar: "/images/defualt.png"
    },
    comments: [],
    in_stock: 12,
    tags: []
  }
];

export const staticCategories = [
  {
    id: 1,
    name: "Electronics",
    main: { name: "Electronics" },
    image: "/images/defualt.png",
    slug: "electronics"
  },
  {
    id: 2,
    name: "Clothing",
    main: { name: "Clothing" },
    image: "/images/defualt.png",
    slug: "clothing"
  },
  {
    id: 3,
    name: "Home & Garden",
    main: { name: "Home & Garden" },
    image: "/images/defualt.png",
    slug: "home-garden"
  },
  {
    id: 4,
    name: "Sports",
    main: { name: "Sports" },
    image: "/images/defualt.png",
    slug: "sports"
  }
];

export const staticTags = [
  { id: 1, name: "New", slug: "new" },
  { id: 2, name: "Sale", slug: "sale" },
  { id: 3, name: "Popular", slug: "popular" },
  { id: 4, name: "Featured", slug: "featured" }
];

export const staticUser = {
  id: 1,
  username: "testuser",
  phone: "+963123456789",
  email: "test@example.com",
  avatar: "/images/defualt.png",
  createdAt: "2024-01-01T00:00:00Z"
};

// Test users for temporary login (without backend)
export const testUsers = [
  {
    phone: "963123456789",
    password: "123456",
    user: {
      id: 1,
      username: "مستخدم تجريبي",
      phone: "+963123456789",
      email: "test1@example.com",
      avatar: "/images/defualt.png",
      createdAt: "2024-01-01T00:00:00Z"
    }
  },
  {
    phone: "963987654321",
    password: "123456",
    user: {
      id: 2,
      username: "مستخدم ثاني",
      phone: "+963987654321",
      email: "test2@example.com",
      avatar: "/images/User.svg",
      createdAt: "2024-01-02T00:00:00Z"
    }
  },
  // Any phone with password "demo" will work
  {
    phone: "demo",
    password: "demo",
    user: {
      id: 999,
      username: "مستخدم تجريبي",
      phone: "+963000000000",
      email: "demo@example.com",
      avatar: "/images/defualt.png",
      createdAt: "2024-01-01T00:00:00Z"
    }
  }
];

// Use fixed timestamps to avoid hydration mismatches
const FIXED_NOW = "2024-01-15T12:00:00.000Z";
const FIXED_ONE_HOUR_AGO = "2024-01-15T11:00:00.000Z";
const FIXED_TWO_HOURS_AGO = "2024-01-15T10:00:00.000Z";

export const staticNotifications = [
  {
    id: 1,
    message: "لديك رسالة جديدة",
    content: JSON.stringify({ message: "لديك رسالة جديدة" }),
    timestamp: FIXED_NOW,
    createdAt: FIXED_NOW,
    type: "message",
    read: false
  },
  {
    id: 2,
    message: "تم شحن طلبك",
    content: JSON.stringify({ message: "تم شحن طلبك" }),
    timestamp: FIXED_ONE_HOUR_AGO,
    createdAt: FIXED_ONE_HOUR_AGO,
    type: "order",
    read: false
  },
  {
    id: 3,
    message: "منتج جديد متاح",
    content: JSON.stringify({ message: "منتج جديد متاح" }),
    timestamp: FIXED_TWO_HOURS_AGO,
    createdAt: FIXED_TWO_HOURS_AGO,
    type: "product",
    read: true
  }
];

export const staticRooms = [
  {
    id: 1,
    room_name: "room_1_2",
    receiver: {
      id: 2,
      name: "Jane Smith",
      avatar: "/images/defualt.png"
    },
    last_message: "Hello, how are you?",
    timestamp: FIXED_NOW
  },
  {
    id: 2,
    room_name: "room_1_3",
    receiver: {
      id: 3,
      name: "Bob Johnson",
      avatar: "/images/defualt.png"
    },
    last_message: "Thanks for the product!",
    timestamp: FIXED_ONE_HOUR_AGO
  }
];

export const staticStories = [
  {
    id: 1,
    account: 1,
    user: {
      id: 1,
      name: "أحمد محمد",
      username: "أحمد محمد",
      avatar: "/images/defualt.png"
    },
    attach: "/images/12.png",
    image: "/images/12.png",
    timestamp: FIXED_NOW,
    comments: [
      {
        id: 1,
        comment: "قصة رائعة!",
        user: {
          id: 2,
          username: "فاطمة علي",
          avatar: "/images/defualt.png"
        },
        created_at: FIXED_ONE_HOUR_AGO,
        story_id: 1
      }
    ]
  },
  {
    id: 2,
    account: 2,
    user: {
      id: 2,
      name: "فاطمة علي",
      username: "فاطمة علي",
      avatar: "/images/defualt.png"
    },
    attach: "/images/3.png",
    image: "/images/3.png",
    timestamp: FIXED_ONE_HOUR_AGO,
    comments: []
  }
];

export const staticUserProducts = [
  {
    id: 1,
    name: "My Product 1",
    price: 99.99,
    image: "/images/defualt.png",
    status: "active"
  },
  {
    id: 2,
    name: "My Product 2",
    price: 149.99,
    image: "/images/defualt.png",
    status: "pending"
  }
];

export const staticSellerStatus = {
  followed: false,
  blocked: false,
  reported: false
};

export const staticProductDetails = {
  id: 1,
  name: "منتج إلكتروني مميز",
  description: "هذا وصف تفصيلي للمنتج. يتضمن جميع الميزات والمواصفات. منتج عالي الجودة مع ضمان شامل.",
  price: 99.99,
  originalPrice: 129.99,
  images: [
    {
      image: "/images/12.png"
    },
    {
      image: "/images/3.png"
    },
    {
      image: "/images/7.png"
    },
    {
      image: "/images/defualt.png"
    }
  ],
  category: {
    main: { name: "Electronics" }
  },
  government: "دمشق",
  seller: {
    id: 1,
    name: "أحمد محمد",
    rating: 4.5,
    totalSales: 150,
    joinedDate: "2023-01-01",
    avatar: "/images/defualt.png"
  },
  specifications: {
    brand: "ماركة مميزة",
    model: "موديل XYZ",
    condition: "جديد"
  },
  location: "دمشق، سوريا",
  createdAt: "2024-01-15T00:00:00Z",
  comments: [],
  in_stock: 10,
  tags: []
};

// Helper function to get product by ID
export const getProductById = (id) => {
  return staticProducts.find(p => p.id === parseInt(id)) || staticProductDetails;
};

// Helper function to get category by slug
export const getCategoryBySlug = (slug) => {
  return staticCategories.filter(cat => cat.main?.name === slug || cat.slug === slug);
};

